import { Box, Skeleton, Stack, Typography } from '@mui/material';

import Loader from 'src/components/Loader/Loader';
import {
    NPIDataGrid,
    NPIDataGridColDef,
    NPIDataGridRow,
} from 'src/components/NPIDataGrid/NPIDataGrid';

export type SepaAgreementTableProps = {
    tableRowData: NPIDataGridRow[];
    tableColDefs: NPIDataGridColDef[];
    loadingTableRowData: boolean;
    loadingAgreementDocumentPdf: boolean;
    title: string;
    dataTestId: string;
};

export function SepaAgreementTable({
    tableRowData,
    tableColDefs,
    loadingAgreementDocumentPdf,
    title,
    loadingTableRowData,
    dataTestId,
}: SepaAgreementTableProps) {
    return (
        <Stack>
            <Typography variant="h3" paddingY={3}>
                {title}
            </Typography>
            {loadingAgreementDocumentPdf && <Loader />}
            {loadingTableRowData ? (
                <Skeleton
                    variant="rounded"
                    animation="wave"
                    placeholder={`Loading ${title}`}
                    width={'100%'}
                    height={'400px'}
                />
            ) : (
                <NPIDataGrid
                    dataTestId={dataTestId}
                    rows={tableRowData}
                    columns={tableColDefs}
                    getRowId={(row) => {
                        return row.id;
                    }}
                />
            )}
        </Stack>
    );
}
